import React, { Component } from "react";
import ProjectDetails from "./ProjectDetails";
import { Element } from "react-scroll";

const PROJECTS = [
  {
    img: "/images/boro.png",
    title: "Boro Design Agency",
    link: "https://borodesign.co.uk/",
    source: "https://github.com/borodesign/borodesign"
  },
  {
    img: "/images/Spacey.PNG",
    title: "Spacey Tech",
    link: "http://www.thespaceytech.com/",
    source: "https://github.com/spaceytech/Spacey_Tech"
  },
  {
    img: "/images/school.png",
    title: "Chinese School London",
    link: "https://www.chineseschoollondon.com/",
    source: "#"
  }
];

class ClientProjects extends Component {
  render() {
    return (
      <Element name="projects" className="headline__client">
        <h1>Client projects</h1>
        <div className="headline__projects">
          {PROJECTS.map(project => {
            return <ProjectDetails details={project} />;
          })}
        </div>
      </Element>
    );
  }
}

export default ClientProjects;



// WEBPACK FOOTER //
// ./src/component/Projects/ClientProjects.js